import {
  AUTO_SPLIT_FETCH_BEGIN,
  AUTO_SPLIT_FETCH_SUCCESS,
  AUTO_SPLIT_FETCH_FAIL,
  AUTO_SPLIT_DISMISS,
  AI_SPLIT_SUCCESS,
} from '../actions/autoSplit';

const initialState = {
  // Store suggestions keyed by sendToken for caching
  suggestions: {},
  // Loading state per record
  loading: {},
  // Error state per record
  errors: {},
  // Track which records have been dismissed by user (don't show banner again)
  dismissed: {},
};

const autoSplitReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTO_SPLIT_FETCH_BEGIN: {
      const { sendToken } = action.payload;
      return {
        ...state,
        loading: {
          ...state.loading,
          [sendToken]: true,
        },
        errors: {
          ...state.errors,
          [sendToken]: null,
        },
      };
    }

    case AUTO_SPLIT_FETCH_SUCCESS: {
      const {
        sendToken,
        parts,
        hasValidSplit,
        fetchedAt,
      } = action.payload;

      return {
        ...state,
        loading: {
          ...state.loading,
          [sendToken]: false,
        },
        suggestions: {
          ...state.suggestions,
          [sendToken]: {
            parts,
            hasValidSplit,
            fetchedAt,
          },
        },
      };
    }

    case AUTO_SPLIT_FETCH_FAIL: {
      const { sendToken, error } = action.payload;

      return {
        ...state,
        loading: {
          ...state.loading,
          [sendToken]: false,
        },
        errors: {
          ...state.errors,
          [sendToken]: error,
        },
      };
    }

    case AUTO_SPLIT_DISMISS: {
      const { sendToken } = action.payload;
      return {
        ...state,
        dismissed: {
          ...state.dismissed,
          [sendToken]: true,
        },
      };
    }

    case AI_SPLIT_SUCCESS: {
      const { sendToken } = action.payload;
      // Clear the suggestion from cache - it's no longer relevant after splitting
      const { [sendToken]: _, ...remainingSuggestions } = state.suggestions;
      return {
        ...state,
        suggestions: remainingSuggestions,
        dismissed: {
          ...state.dismissed,
          [sendToken]: true, // Don't show banner for this record anymore
        },
      };
    }

    default:
      return state;
  }
};

export default autoSplitReducer;
